import React from 'react';
import { TabContent, DashboardDivider, NoDataDiv } from './styles';
import { NoData } from './styles';

import FlowCard from '../../../../../../CommonComponents/FlowCard/FlowCard';
import InvestmentOptionDetailsMobile from '../../../../../../Epics/Investments/Pages/InvestmentOptionDetails/InvestmentOptionDetailsMobile';
import PropTypes from 'prop-types';

export default function TabPaneMobile(props) {
  const {
    tabComponent,
    tabIndex,
    length,
    text,
    tabConfig,
    itemData,
    clicked
  } = props;
  function styleConfig() {
    return {
      alternatingBg: false,
      cardBorder: false,
      cardPadding: true
    };
  }
  switch (tabComponent) {
    case 'card':
      if (props.isLoading) return <div>isLoading</div>;
      return (
        <TabContent>
          {length === 0 ? (
            <NoDataDiv>
              <NoData>{text}</NoData>
            </NoDataDiv>
          ) : (
            itemData &&
            itemData.map((pool, dataIndex) => (
              <>
                <FlowCard
                  cardConfig={tabConfig(pool, dataIndex, () => clicked(pool))[tabIndex].config}
                  styleConfig={styleConfig()}
                  dataIndex={dataIndex}
                  length={length}
                  key={pool.txnId}
                />
                {dataIndex == itemData.length - 1 ? '' : <DashboardDivider />}
              </>
            ))
          )}
        </TabContent>
      );
    case 'table':
      return (
        <TabContent>
          {length === 0 ? (
            <NoDataDiv>
              <NoData>{text}</NoData>
            </NoDataDiv>
          ) : (
            <InvestmentOptionDetailsMobile
              itemData={itemData}
              tabIndex={tabIndex}
              accountType={props.accountType}
              activeKey={props.activeKey ? props.activeKey : 'Standard'}
            />
          )}
        </TabContent>
      );
    default:
      return 'Not passed component type';
  }
}

TabPaneMobile.propTypes = {
  activeKey: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.numer
  ]),
  clicked: PropTypes.func,
  isLazyLoading: PropTypes.bool,
  itemData: PropTypes.array,
  length: PropTypes.number,
  tabComponent: PropTypes.string,
  tabConfig: PropTypes.func,
  tabIndex: PropTypes.number,
  text: PropTypes.string,
}